module.exports = __webpack_public_path__ + "img/Angiogenesis-PRCA_10X_ANS.34ab0eb6.png";